import styled from 'styled-components'
import backgroundImage from 'images/lowpolyblack.JPG'

export const Wrapper = styled.div`
  margin-left: 250px;
`

export const Header = styled.div`
  position: fixed;
  font-size: 2em;
  font-weight: bold;
  padding: 1rem 4rem;
  width: 100%;
  background-color: white;
  z-index: 1;
  border-bottom: 1px solid #eee;
`
export const Body = styled.div``
export const Footer = styled.div``

export const SideContainer = styled.div``
export const SidePanel = styled.nav`
  background: url(${backgroundImage});
  max-width: 250px;
  min-width: 250px;
  min-height: 100vh;
  position: fixed;
  border-right: 1px solid black;
  z-index: 3;
`
export const MarginTop = styled.div`
  height: 6rem;
`
